export default "__VITE_ASSET__CUhZRbzE__"